import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Correct from "../../images/Correct.svg";
import Incorrect from "../../images/Incorrect.svg";
import styles from "./styles";
import "animate.css/animate.css";

const EvaluatorModal = ({
  classes,
  nextQuestion,
  answeredCorrectly,
  question,
  questionSetIndex,
}) => {
  console.log("question", question)
  const renderCalculation = () => (
    <div className={classes.modalCalculation}>
    <h2 className={classes.calculationTitle}>
      {question.answerDetail.heading}
    </h2>
    <div className={classes.calculationContainer}>
      <div className={classes.fraction}>
        <div className={classes.numerator}>
        {question.answerDetail.numinator}
        </div>
        <div className={classes.divider} />
        <div className={classes.denominator} dangerouslySetInnerHTML={{ __html: question.answerDetail.denuminator }}>
        </div>
      </div>
      <span className={classes.operator}>×</span>
      <span className={classes.percentage}>100</span>
      <span className={classes.equals}>=</span>
      <span className={classes.result}>{question.answer}</span>
    </div>
  </div>
  )

  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${questionSetIndex < 2 ? classes.evaluatorModalContainer :  classes.evaluatorModalContainerMCQ}`}>
          <Grid container justify="center">
            {answeredCorrectly ? (
              <img
                alt=""
                src={Correct}
                className={classes.correctIncorrectIcon}
              />
            ) : (
              <img
                alt=""
                src={Incorrect}
                className={classes.correctIncorrectIcon}
              />
            )}
          </Grid>
          { questionSetIndex < 2 ?
            <Typography className={classes.evalDesc}>
              {answeredCorrectly
                ? question.rightAnswerText
                : question.wrongAnswerText}
            </Typography>
          : renderCalculation()
          }
          <Grid container justify="center">
            <Button className={classes.submitButton} onClick={nextQuestion}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(EvaluatorModal);
